/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-09 17:01:23
 * @LastEditors: caiqin.xie
 * @message: 服务支持主页-联系我们
 */
import React from "react";
import styles from "../../index.module.scss";
import ChatWindow from "../ChatWindow";
import LazyMedia from "@/components/LazyMedia"

interface IProps {
  ctry: string;
  words: Record<string, string>;
  contactData: Record<string, any>; // 联系我们数据
}

const supportOnline = require('../../assets/support_online.png')
const supportMail = require("../../assets/support_mail.png")

const ContactUs = (props:IProps) => {
  const {ctry, words, contactData} = props

  const [visibleChat, setVisibleChat] = React.useState(false); // 聊天窗口是否可见
  
  // const chatClick = () => {
  //   const _Window = window as any
  //   _Window.OpenContactUs && _Window.OpenContactUs();
  // }

  return (
    <section className={styles["support-contact-us"]}>
      <h2>
        {words.support_home_contactUs_title}
        {/* Contact Us */}
      </h2>
      <div className={styles["contact-wrap"]}>
        <div className={`${styles['contact-item']} ${styles['contact-item-bg']}`}></div>
        <div className={styles["contact-item"]}>
          <h3 className={styles["mb-24"]}>
            {words.support_home_contactUs_hotline}
            {/* Hotline */}
          </h3>
          <p className={styles["cor-purple"]}>
            {contactData?.telephone}
          </p>
          <p>
            {contactData?.workingTime}
          </p>
          {contactData?.comment && (
            <p>
              {contactData?.comment}
            </p>
          )}
        </div>
        <div className={styles["contact-item"]}>
          <LazyMedia type="image" src={supportOnline} alt={words.support_home_contactUs_online} />
          <h3>
            {words.support_home_contactUs_online}
            {/* Chat */}
          </h3>
          <p>
            {contactData?.workingTime}
          </p>
          <p className={styles["learn-more-purple"]} onClick={() => setVisibleChat(true)}>
            {words.support_home_contactUs_online_chatnow}
            {/* Chat now */}
          </p>
        </div>
        <div className={styles["contact-item"]}>
          <img src={supportMail} alt={words.support_home_contactUs_email} />
          <h3>
            {words.support_home_contactUs_email}
            {/* Email */}
          </h3>
          <p>
            {contactData?.emailAddress}
          </p>
          <p className={styles["learn-more-purple"]}>
            <a href={`/${ctry}/support/contact-support`}>
              {words.support_home_contactUs_email_us}
            </a>
            {/* Email us */}
          </p>
        </div>
        {/* 聊天窗口 */}
        <ChatWindow ctry={ctry} words={words} visibleChat={visibleChat} setVisibleChat={setVisibleChat} />
      </div>
    </section>
  )
}
export default ContactUs
